export default {
  authGroups: {
    systemAdmin: {
      label: 'Системийн админ',
      label_other: 'Системийн админууд',
      description: 'OF Arena системийн админууд',
    },
    surveyManager: {
      label: 'Судалгааны менежер',
      label_other: 'Судалгааны менежерүүд',
      description: 'OF Arena судалгааны менежерүүд',
    },
    surveyAdmin: {
      label: 'Судалгааны админ',
      label_other: 'Судалгааны админууд',
      description: 'Бүрэн эрх',
    },
    surveyEditor: {
      label: 'Судалгааны редактор',
      label_other: 'Судалгааны редакторууд',
      description: 'Судалгаа, бүртгэл засах, хэрэглэгч урих боломжтой',
    },
    dataEditor: {
      label: 'Өгөгдөл засагч',
      label_other: 'Өгөгдөл засагчид',
      description: 'Өгөгдөл оруулах алхамд бүртгэл засах боломжтой',
    },
    dataCleanser: {
      label: 'Өгөгдөл цэвэрлэгч',
      label_other: 'Өгөгдөл цэвэрлэгчид',
      description: 'Өгөгдөл цэвэрлэх алхамд бүртгэл засах боломжтой',
    },
    dataAnalyst: {
      label: 'Өгөгдөл аналист',
      label_other: 'Өгөгдөл аналистууд',
      description: 'Өгөгдөл шинжилгээний алхамд бүртгэл засах боломжтой',
    },
    surveyGuest: {
      label: 'Судалгааны зочин',
      label_other: 'Судалгааны зочид',
      description: 'Бичлэгийг үзэх боломжтой',
    },
  },
}
